import React, { useEffect, useState } from "react";
import PaginationControls from "./PaginationControls";

const ITEMS_PER_PAGE = 16;

function matchesStudent(record, searchTerm) {
  const term = searchTerm.toLowerCase();
  const studentIdStr = String(record.student_id || "").toLowerCase();
  const studentStr = (record.student_string || "").toLowerCase();
  return studentStr.includes(term) || studentIdStr.includes(term);
}

export default function CollectPaymentModal({
  isOpen,
  isLive,
  payments,
  onClose,
  onConfirm,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const paymentIdKey = isLive ? "payment_id" : "video_payment_id";

  useEffect(() => {
    if (!isOpen) return;
    setSearchTerm("");
    setPage(1);
  }, [isOpen, isLive]);

  if (!isOpen) return null;

  const filteredPayments = payments.filter((payment) => matchesStudent(payment, searchTerm));
  const totalPages = Math.ceil(filteredPayments.length / ITEMS_PER_PAGE);
  const paginatedPayments = filteredPayments.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-3/4 max-h-screen overflow-y-auto">
        <h3 className="text-xl font-semibold mb-4">
          Pending {isLive ? "Live" : "Video"} Payments
        </h3>
        <div className="mb-4 flex">
          <input
            type="text"
            placeholder="Search by student name or ID..."
            className="border p-2 rounded mr-2 w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <table className="min-w-full bg-white border border-gray-200">
          <thead>
            <tr className="bg-gray-200">
              <th className="px-4 py-2 border">Payment ID</th>
              <th className="px-4 py-2 border">Student</th>
              <th className="px-4 py-2 border">Month</th>
              <th className="px-4 py-2 border">Status</th>
              <th className="px-4 py-2 border">Amount</th>
              <th className="px-4 py-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedPayments.map((payment) => (
              <tr key={payment[paymentIdKey]}>
                <td className="px-4 py-2 border">{payment[paymentIdKey]}</td>
                <td className="px-4 py-2 border">{payment.student_string}</td>
                <td className="px-4 py-2 border">{payment.month}</td>
                <td className="px-4 py-2 border">{payment.status}</td>
                <td className="px-4 py-2 border font-medium">
                  $
                  {Math.max(
                    0,
                    Number(payment.total_amount || 0) - Number(payment.discount || 0)
                  ).toFixed(2)}
                </td>
                <td className="px-4 py-2 border">
                  <button
                    onClick={() => onConfirm(payment[paymentIdKey])}
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                  >
                    Confirm
                  </button>
                </td>
              </tr>
            ))}
            {paginatedPayments.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center py-4">
                  No pending {isLive ? "live" : "video"} payments found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <PaginationControls page={page} totalPages={totalPages} onPageChange={setPage} />
        <button
          onClick={onClose}
          className="mt-4 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
        >
          Close
        </button>
      </div>
    </div>
  );
}
